module.exports = __webpack_public_path__ + "static/media/2-iveco.9688521d.jpg";